module.exports = __webpack_public_path__ + "images/marketing/peeps/grant_ammons.jpg";